import type { SocialProfileNetworkType } from '@/types/socialProfileType';

import { THREADS } from '@/lib/socialProfile';

export const RESTRICTED_NETWORKS: SocialProfileNetworkType[] = [THREADS];
